import { Grid } from '@chakra-ui/react';
import React from 'react';
import { Card, CardBody, CardHeader } from 'ui-components';
import { SkeletonColored } from '~/screens/MyAgency/components/StackView/CreatorSkeleton';
import { convertPxToRems } from '~/utils-ts';

export const ChartSkeleton = () => {
  return (
    <div className="flex flex-col gap-12 p-4">
      <div className="flex flex-col gap-4">
        <SkeletonColored
          height={6}
          width={convertPxToRems(162)}
          startColor="var(--media-kit-background-skeleton)"
        />
        <div className="grid grid-cols-[repeat(auto-fill,_minmax(356px,_1fr))] gap-4">
          {Array(3)
            .fill(0)
            .map((_, index) => (
              <Card
                key={index}
                pointerEvents="none"
                backgroundColor="var(--media-kit-background-primary)"
                borderColor="var(--media-kit-background-alpha)"
              >
                <CardHeader className="mb-2">
                  <SkeletonColored
                    className="h-6 w-40"
                    startColor="var(--media-kit-background-skeleton)"
                  />
                </CardHeader>
                <CardBody>
                  <SkeletonColored
                    height="292px"
                    startColor="var(--media-kit-background-skeleton)"
                  />
                </CardBody>
              </Card>
            ))}
        </div>
        <SkeletonColored
          className="h-3 w-40"
          startColor="var(--media-kit-background-skeleton)"
        />
      </div>

      <div className="flex flex-col gap-4">
        <SkeletonColored
          className="h-6 w-40"
          startColor="var(--media-kit-background-skeleton)"
        />
        <Grid templateColumns="repeat(auto-fit, minmax(300px, 1fr))" gap={4}>
          {[...Array(9)].map((_) => (
            <Card
              minWidth={convertPxToRems(300)}
              pointerEvents="none"
              backgroundColor="var(--media-kit-background-primary)"
              borderColor="var(--media-kit-background-alpha)"
            >
              <CardHeader
                paddingBottom={convertPxToRems(10)}
                width={convertPxToRems(132)}
              >
                <SkeletonColored
                  className="mb-2 h-3 w-full"
                  startColor="var(--media-kit-background-skeleton)"
                />
              </CardHeader>
              <CardBody>
                <SkeletonColored
                  className="h-10 w-full max-w-20"
                  startColor="var(--media-kit-background-skeleton)"
                />
              </CardBody>
            </Card>
          ))}
        </Grid>
        <SkeletonColored
          className="mt-2 h-3 w-32"
          startColor="var(--media-kit-background-skeleton)"
        />
      </div>
    </div>
  );
};
